import * as React from 'react';

import { getDisplayName } from './getDisplayName';

// oxlint-disable-next-line typescript/no-explicit-any
export function wrapDisplayName(Component: React.ComponentType<any>, hocName: string): string {
  return `${hocName}(${getDisplayName(Component)})`;
}
